import React from 'react'
import PropTypes from 'prop-types'
import './section-title.css'

const SectionTitle = ({ title, subtitle, style, titleStyle, small, withoutContainer, onClick }) => (
  <div onClick={onClick} className={`SectionTitle ${small ? 'small' : ''}`} style={style}>
    <div className={withoutContainer ? '' : 'container-wide'}>
      <h3 style={titleStyle}>{title}</h3>
      <p>{subtitle}</p>
    </div>
  </div>
)

SectionTitle.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  small: PropTypes.bool,
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  style: PropTypes.object,
  titleStyle: PropTypes.object,
  withoutContainer: PropTypes.bool,
  onClick: PropTypes.func
}

SectionTitle.defaultProps = {
  withoutContainer: false,
  onClick () { }
}

export default SectionTitle
